import dayjs from "dayjs";
import "dayjs/locale/id";
import "dayjs/locale/th";
import "dayjs/locale/vi";
import "dayjs/locale/zh-cn";
import "dayjs/locale/zh-tw";
import duration from "dayjs/plugin/duration";
import isBetween from "dayjs/plugin/isBetween";
import timezone from "dayjs/plugin/timezone";
import utc from "dayjs/plugin/utc";

export const initDayjs = (tz: ServeTimezone) => {
  dayjs.extend(duration);
  dayjs.extend(isBetween);
  dayjs.extend(utc);
  dayjs.extend(timezone);
  dayjs.tz.setDefault(tz);
};

export default dayjs;
